import React from "react";

const darkenHex = (hex, factor = 0.2) => {
	if (hex.startsWith("#")) hex = hex.slice(1);

	const r = parseInt(hex.slice(0, 2), 16);
	const g = parseInt(hex.slice(2, 4), 16);
	const b = parseInt(hex.slice(4, 6), 16);

	const darken = (colorValue) => Math.max(0, colorValue - colorValue * factor);

	const newR = Math.round(darken(r));
	const newG = Math.round(darken(g));
	const newB = Math.round(darken(b));

	return `#${newR.toString(16).padStart(2, "0")}${newG.toString(16).padStart(2, "0")}${newB.toString(16).padStart(2, "0")}`;
};

const getTextColor = (hex) => {
	if (!hex) return "#000000";
	if (hex.startsWith("#")) hex = hex.slice(1);

	const r = parseInt(hex.slice(0, 2), 16);
	const g = parseInt(hex.slice(2, 4), 16);
	const b = parseInt(hex.slice(4, 6), 16);

	const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

	return luminance > 128 ? "black" : "white";
};

const Tag = ({ id, text, hex_color, onClick }) => {
	const textColor = getTextColor(hex_color);
	const borderColor = darkenHex(hex_color);

	const handleClick = (id) => {
		if (!id) return;
		if (onClick) onClick(id);
	};

	return (
		<span
			onClick={() => handleClick(id)}
			className="tag is-rounded has-text-weight-bold is-clickable m-1"
			style={{
				backgroundColor: hex_color,
				color: textColor,
				border: `2px solid ${borderColor}`,
				justifyContent: "center",
				alignItems: "center",
				height: "25px",
				minWidth: "100px",
				padding: "0 15px",
			}}
		>
			{text}
		</span>
	);
};

export default Tag;
